import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DowntimeBanner } from 'src/app/shared/models/downtime-banner.model';

@Injectable()
export class DowntimeBannerService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiUrl = '/api/dealership';

  getDowntimeBanner(): Observable<DowntimeBanner> {
    return this.httpClient.get<DowntimeBanner>(`${this.apiUrl}/application/downtime-banner`);
  }
}
